import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, UrlSerializer, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './shared/interceptors/http.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { CustomUrlSerializer } from './serializers/custom-url-serializer';
import { MODAL_CONTENT_COMPONENT } from './shared/modal-content/modal-content.token';
import { ModalContentComponent } from './shared/modal-content/modal-content.component';
import { ChunkReloadErrorHandler } from './shared/error-handler/chunk-reload-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    // Replay user events (mainly nav taps on product links / header) captured
    // during the SSR→hydration window so they aren't dropped on slow devices.
    provideClientHydration(withEventReplay()),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideHttpClient(
      withFetch(),
      withInterceptors([httpInterceptor])
    ),
    // Supplies the modal host component to ModalContentService via DI so the
    // service doesn't statically import it — breaks a circular dependency.
    { provide: MODAL_CONTENT_COMPONENT, useValue: ModalContentComponent },
    // Sentry's ErrorHandler (DEV-11772), plus a one-shot hard reload when a stale
    // post-deploy chunk fails to load (NG0750 / ChunkLoadError / module MIME).
    { provide: ErrorHandler, useClass: ChunkReloadErrorHandler },
  ]
};
